import React from 'react';
import { Hash, User, Music, Mic2 } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../lib/utils';

export function ServerList() {
  const location = useLocation();
  const currentPath = location.pathname.split('/')[2] || 'chat';

  return (
    <div className="w-[72px] bg-background-primary h-screen flex flex-col items-center pt-4 space-y-2 flex-shrink-0 border-r border-divider">
      <Link
        to="/app/profile"
        className={cn(
          "w-12 h-12 rounded-full flex items-center justify-center transition-colors",
          currentPath === 'profile'
            ? 'bg-accent-primary text-white'
            : 'bg-background-secondary text-text-primary hover:bg-accent-primary'
        )}
      >
        <User size={24} />
      </Link>

      <div className="w-8 h-0.5 bg-divider my-2"></div>

      <Link
        to="/app/chat"
        className={cn(
          "w-12 h-12 rounded-full flex items-center justify-center transition-colors",
          currentPath === 'chat'
            ? 'bg-accent-primary text-white'
            : 'bg-background-secondary text-text-primary hover:bg-accent-primary'
        )}
      >
        <Hash size={24} />
      </Link>

      <Link
        to="/app/artist-hub"
        className={cn(
          "w-12 h-12 rounded-full flex items-center justify-center transition-colors",
          currentPath === 'artist-hub'
            ? 'bg-accent-primary text-white'
            : 'bg-background-secondary text-text-primary hover:bg-accent-primary'
        )}
      >
        <Mic2 size={24} />
      </Link>

      <Link
        to="/app/producer-hub"
        className={cn(
          "w-12 h-12 rounded-full flex items-center justify-center transition-colors",
          currentPath === 'producer-hub'
            ? 'bg-accent-primary text-white'
            : 'bg-background-secondary text-text-primary hover:bg-accent-primary'
        )}
      >
        <Music size={24} />
      </Link>
    </div>
  );
}